export default [
    {
        name: "",
        navbar: {
            name: 'LandingPage'
        }
    },
]